import React, {Component} from 'react';
import {connect} from 'react-redux';
import Head from '../../../Structure/components/Head/Head';
import Footer from '../../../Structure/components/Footer/Footer';
import {
    getAnimalsProtectora,
    getAnimalsProtectoraAvanzado,
    loadInfoProtectoraDetail,
    loadInfoProtectoraDetailImagenYVideo,
    modeEmail,
    remove,
    removing,
    resetAnimalsProtectora,
    resetInfoProtectoraDetail,
} from '../../../AnimalList/actions/actionsAnimalList';
import {resetFilters} from '../../../AnimalList/actions/actionsFilterAnimals';
import Alert from 'react-s-alert';
import AlertsConteiner from '../../../Shared/components/Alerts/AlertsConteiner';
import WaitBlock from "../../../Shared/components/Alerts/WaitBlock";
import {init, sendEmail} from "../../../Shared/actions/actionsContactByEmail";
import {changeStepWaitBlock, showWaitBlock} from "../../../Structure/actions/actionsStructure";
import {checkIsLogin} from "../../../AdminProtectora/actions/actionsAdmin";
import {browserHistory} from "react-router";
import {
    PATH_BUSCADOR_ANIMALES_ADMIN_ADMINANIMALS_ID,
    PATH_BUSCADOR_ANIMALES_ADMIN_LOGIN,
    PATH_PROTECTORA_ID
} from "../../../../App/RouterAdopta";
import NewProtectoraDetailContainer from "./NewProtectoraDetailContainer";


const ANIMALS_CONTROL = "animalsProtectora"
const ANIMALS_CONTROL_DETAIL = "animalDetailProtectora"

class NewProtectoraDetailPage extends Component {

    constructor(props) {
        super(props);

        this.props.isLogin();


        var width = window.innerWidth;
        if (width < 992) {
            this.state = {
                elementsPerPage: 12,
                elementsPerRow: 2
            }
        } else {
            this.state = {
                elementsPerPage: 12,
                elementsPerRow: 3
            }
        }
        this.state.animalsProtectoraRequested = false
        this.state.animalsRecomendationRequested = false


        this.loadAnimals = this.loadAnimals.bind(this);
        this.EventWaitBlock = this.EventWaitBlock.bind(this);
    }

    showLoader() {
    }

    loadAnimals(pageNumber) {
// const protectoraId = this.props.reducerAccess.isLogin
        //     ? this.props.reducerAccess.id :
        //     this.props.params.id
        //         ? this.props.params.id
        //         : this.props.animalDetailProtectora.infoProtectoraDetail._id;

        const protectoraIdParam = this.props.params.id;

        if (protectoraIdParam !== undefined) {
            let info = {
                pag: pageNumber,
                numPerRow: this.state.numPerRow,
                numPerPage: this.state.numPerPage,
                varsData: {id_protectora: protectoraIdParam}
            };

            if (!this.props.avanzado) {
                this.props.getAnimalsProtectora(info);
            } else {
                this.props.getAnimalsProtectoraAvanzado(info);
            }
        }
    }


    EventWaitBlock(event) {
        //console.log("NewProtectoraDetailPage::EventWaitBlock() -> event");

        if (event === "go") {

                this.props.sendEmail(this.props.infoProtectoraDetail._id);
        } else {
            if (this.props.waitBlock.stepWaitBlock === 200 || this.props.waitBlock.stepWaitBlock === 201) {
                    Alert.success('Enviado correctamente', {
                        position: 'top-right',
                        effect: 'slide',
                        timeout: 6000,
                        customFields: {
                            messageItem: 2,
                            showIconClosed: true,
                            icon: "las la-2x la-thumbs-up"
                        }
                    });
                    this.props.init("animalsProtectora");
            } else {
                Alert.error('Error: ' + this.props.waitBlock.errorWaitBlock, {
                    position: 'top-right',
                    effect: 'slide',
                    timeout: 6000,
                    customFields: {
                        messageItem: 2,
                        showIconClosed: true,
                        icon: "las la-2x la-exclamation-triangle"
                    }
                });
            }
            this.props.changeStepWaitBlock(0);
            this.props.changeWaitBlock(false);
        }
    }

    render() {
        let activeCards = {
            animal: true,
            imagenyvideo: true,
            protectora: false,
            metricasAnimal: false
        };
        // const protectoraId = (this.props.reducerAccess.isLogin)
        //     ? this.props.reducerAccess.id : (this.props.params.id) ? this.props.params.id : this.props.animalDetailProtectora.infoProtectoraDetail._id;
        const protectoraId = this.props.params.id
        let showCardProtectoraDetail = false;
        if (this.props.route.path.startsWith(PATH_PROTECTORA_ID)) {
            showCardProtectoraDetail = true;
        }

        const isAdminAnimals = (this.props.access && this.props.access.id && this.props.access.id === protectoraId && this.props.route && this.props.route.path && this.props.route.path.startsWith(PATH_BUSCADOR_ANIMALES_ADMIN_ADMINANIMALS_ID))

        if (isAdminAnimals) {
            activeCards.metricasAnimal = true
        } else {
            activeCards.metricasAnimal = false
        }

        return (
            <div>
                <Head
                    previousPath={"protectoraDetail"}
                />
                {this.props.waitBlock.showWaitBlock &&
                <WaitBlock
                    message={"Espere por favor..."}
                    methodChange={this.EventWaitBlock}
                />
                }
                <div id="animals-list" className="container main-content">
                    <NewProtectoraDetailContainer
                        showCardProtectoraDetail={showCardProtectoraDetail}
                        infoProtectoraDetail={this.props.infoProtectoraDetail}
                        animalsProtectora={this.props.animalsProtectora}
                        animalsControl={ANIMALS_CONTROL}
                        animalsControlDetail={ANIMALS_CONTROL_DETAIL}
                        elementsPerRow={this.state.elementsPerRow}
                        elementsPerPage={this.state.elementsPerPage}
                        loader={this.showLoader.bind(this)}
                        loadAnimals={this.loadAnimals}
                        isAdminAnimals={isAdminAnimals}
                        access={this.props.access}
                        waitBlock={this.props.waitBlock}
                        params={this.props.params}
                    />

                    <Alert stack={true} html={true} contentTemplate={AlertsConteiner}/>
                </div>
                <Footer
                    percent={100}
                    configFooter={
                        {"moreInfo": false}
                    }
                />
            </div>
        );
    }

    componentWillMount() {
        // if (!this.props.reducerAccess.isLogin) {
        //     browserHistory.push('/login');
        // }else{
        //5ed931d79ddab81ad41852a6


        //console.log("AnimalDetailPage::componentWillMount()");
        this.props.resetInfoProtectoraDetail(ANIMALS_CONTROL)
        this.props.resetAnimalsProtectora()


        this.props.loadInfoProtectoraDetail(this.props.params.id, ANIMALS_CONTROL, "completa");


        this.props.modeEmail(false, this.props.animalsControl);

        //Initial scroll
        this.loadAnimals(0);


        // console.log("AnimalDetailPage::componentWillMount() -> Haciendo scrollTop");
        $('body,html').stop(true, true).animate({  scrollTop: 0        }, 450);


        // if (this.props && this.props.route && this.props.route.path && this.props.route.path.startsWith('/buscador/admin/adminAnimal')) {
        //
        //
        //     if (!this.props.access.isLogin) {
        //         return browserHistory.push(PATH_BUSCADOR_ANIMALES_ADMIN_LOGIN)
        //     } else if (this.props.access.id !== this.props.params.id) {
        //         this.props.params.id = this.props.access.id
        //         return browserHistory.push(PATH_BUSCADOR_ANIMALES_ADMIN_ADMINANIMALS_ID + this.props.access.id)
        //     } else {
        //         this.loadAnimals(0);
        //     }
        // } else {
        //
        //
        //     this.props.resetFilters("filtersControlProtectora");
        //     this.props.loadInfoProtectoraDetail(this.props.params.id, ANIMALS_CONTROL, "completa");
        //     // this.props.loadInfoProtectoraDetailImagenYVideo(this.props.idProtectora, "pesada");
        //     this.loadAnimals(0);
        //
        //
        //     this.props.changeStepWaitBlock(0);
        //     this.props.showWaitBlock(false);
        // }
    }

    componentDidMount() {
        this.showLoader();

    }

    componentDidUpdate(prevProps, prevState) {

        if (this.props.params.id !== prevProps.params.id) {
            this.props.resetInfoProtectoraDetail(ANIMALS_CONTROL)
            this.props.resetAnimalsProtectora()
            this.setState({
                ...this.state,
                animalsProtectoraRequested: false,
            })
            this.loadAnimals(0)
            //console.log("AnimalDetailPage::componentDidUpdate() -> Haciendo scrollTop");
            $('body,html').stop(true, true).animate({                scrollTop: 0            }, 450);

        }


        // if (!this.state.animalsProtectoraRequested) {
        //
        //     if ((this.props.infoProtectoraDetail && this.props.infoProtectoraDetail._id !== undefined && this.props.infoProtectoraDetail._id !== prevProps.infoProtectoraDetail._id)
        //         || ((!this.props.animalsProtectora || !this.props.animalsProtectora.animals || this.props.animalsProtectora.animals.length === 0) && (this.props.infoProtectoraDetail && this.props.infoProtectoraDetail._id))
        //         || (this.props.infoAnimalDetail.especie !== prevProps.infoAnimalDetail.especie && this.props.infoProtectoraDetail._id)) {
        //
        //         //console.log("Hay protectora nueva cargada!");
        //         // this.loadDataAnimalsProtectora(this.props.infoProtectoraDetail._id, 0)
        //         // this.setState({
        //         //     ...this.state,
        //         //     animalsProtectoraRequested: true
        //         // })
        //     }
        // }


        if (this.props.waitBlock.showWaitBlock) {
            $('#modal-container').removeClass('out').addClass("one");
            $('body').addClass('modal-active');
        } else {
            $('body').removeClass('modal-active');
        }
    }


}

function mapStateToProps(state, ownProps) {
    //console.log("EntityProtectoraDetailContainer::mapStateToProps()");
    // console.log("animalsProtectora.elementsPerRow = '" + state.animalsProtectora.elementsPerRow + "'");
    // console.log("animalsProtectora.elementsPerPage = '" + state.animalsProtectora.elementsPerPage + "'");
    return {

        infoProtectoraDetail: state[ANIMALS_CONTROL_DETAIL].infoProtectoraDetail,
        animalsProtectora: {
            animals: state.animalsProtectora.list,
            totalRecord: state.animalsProtectora.totalRecord,
            pag: state.animalsProtectora.pag
        },
        access: state.access,


        animals: state.animalsProtectora.list,
        totalRecord: state.animalsProtectora.totalRecord,
        pag: state.animalsProtectora.pag,

        // elementsPerRow: state.animalsProtectora.elementsPerRow,
        // elementsPerPage: state.animalsProtectora.elementsPerPage,
        avanzado: state.filtersControlProtectora.avanzado,
        showHead: state.structureControl.showHead,
        showFooter: state.structureControl.showFooter,
        animalDetailProtectora: state.animalDetailProtectora,
        isRemoving: state.animalsProtectora.isRemoving,
        waitBlock: state.structureControl,
        filter: state["filtersControlProtectora"]
    }
}

//El primer parametro es el mapeo de las props y el segundo las acciones- luego se le coloca que componente se ejecuta
export default connect(mapStateToProps, {

    modeEmail,
    getAnimalsProtectora,
    getAnimalsProtectoraAvanzado,
    resetFilters,
    sendEmail: sendEmail,
    changeWaitBlock: showWaitBlock,
    changeStepWaitBlock,
    init,
    removing,
    remove,
    isLogin: checkIsLogin,
    loadInfoProtectoraDetail,
    loadInfoProtectoraDetailImagenYVideo,
    resetInfoProtectoraDetail,
    resetAnimalsProtectora,
})(NewProtectoraDetailPage)
